import { ErrorMap } from '../../../_base/validation/ErrorMap';

export class ResetPasswordVM {
    password = '';
    confirmationPassword = '';
    errors: ErrorMap = {};
    dontSuggestPasswordReset = false;
}